import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Grid,
  Select,
  MenuItem,
  Box,
  Divider,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MaterialTable from "./Mateial";
import { Helmet } from "react-helmet";
import { useSelector, useDispatch } from "react-redux";
import {
  product_actions,
  adcard_actions,
  cart_actions,
} from "../../redux-store/index.js";

import Modal from "react-responsive-modal";
import backend from "../../api";
import { addImpression, Event, gaAddToCart } from "../Tracking/Tracking";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100%",
  },
  field: {
    marginBottom: theme.spacing(2),
    fontSize: "16px",
    width: "100%",
  },
  button: {
    backgroundColor: "green",
    color: "white",
    width: "65%",
    heigth: "20px",
    fontSize: "0.55rem",
  },
  header: {
    textJustify: "center",
    justifyContent: "center",
    fontWeight: "bolder",
    color: "#dc1c24",
  },
  done: {
    backgroundColor: "#dc1c24",
    color: "white",
    marginTop: theme.spacing(5),
    width: "70%",
    height: "25px",
  },
  container: {
    [theme.breakpoints.up("lg")]: {
      width: "100%",
      margin: theme.spacing(1),
      marginTop: theme.spacing(3),
      padding: theme.spacing(1),
    },
    margin: theme.spacing(2),
    marginTop: theme.spacing(15),
    overflowX: "auto",
    marginRight: "auto",
    marginLeft: "auto",
    display: "flex",
    justifyContent: "center",
    margin: theme.spacing(2),
    marginTop: theme.spacing(15),
    padding: theme.spacing(2),
  },
  paper: {
    position: "absolute",
    width: 350,
    backgroundColor: "white",
    padding: theme.spacing(2, 4, 3),
    top: "20%",
    left: "35%",
    outline: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  size: {
    [theme.breakpoints.down("lg")]: {
      width: "100%",
      marginLeft: theme.spacing(1),
    },
    [theme.breakpoints.down("md")]: {
      width: "95%",
      marginLeft: theme.spacing(5),
    },
    [theme.breakpoints.down("sm")]: {
      width: "90%",
      marginLeft: theme.spacing(3),
    },
    [theme.breakpoints.down("xs")]: {
      width: "80%",
      marginLeft: theme.spacing(6),
    },
  },
}));

const ProductCatalogue = (props) => {
  const { id } = useParams();
  const { _id, sorting, searchTerm } = props;
  const merchant_id = _id ? _id : id;
  const { items: cart } = useSelector((state) => state.cart);
  const classes = useStyles();
  const dispatch = useDispatch();
  const [vacProducts, setVacProducts] = useState([]);
  const [state, setState] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [open, setOpen] = useState(false);
  const [merchant, setMerchant] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const { data } = useSelector((state) => state.products);
  const title = "Products";
  console.log("data", data);
  useEffect(() => {
    if (data) {
      const myData = data.filter(
        (i) => i.merchant_user && i.merchant_user._id === merchant_id
      );
      setMerchant(myData);
    }
  }, [data, merchant_id]);

  useEffect(() => {
    if (cart) {
      //cart merchant_user populated or not
      if (cart.length === 0) {
        setState(false);
      } else if (
        (cart.length > 0 &&
          cart[0].product.merchant_user._id === merchant_id) ||
        cart[0].product.merchant_user === merchant_id
      ) {
        setState(false);
      } else if (
        (cart.length > 0 &&
          cart[0].product.merchant_user._id !== merchant_id) ||
        cart[0].product.merchant_user === merchant_id
      ) {
        setState(true);
      }
    }
  }, [cart, merchant_id]);
  let obj = [...merchant];
  useEffect(() => {
    if (
      (merchant.length > 0 && sorting === "Ascending") ||
      sorting === "Descending"
    ) {
      if (sorting === "Descending") {
        obj.sort(
          (a, b) =>
            parseInt(b.member_prize_value) - parseInt(a.member_prize_value)
        );
        setMerchant(obj);
      } else if (sorting === "Ascending") {
        obj.sort(
          (a, b) =>
            parseInt(a.member_prize_value) - parseInt(b.member_prize_value)
        );

        setMerchant(obj);
      }
    }
  }, [sorting]);
  useEffect(() => {
    if (searchTerm !== "" && merchant.length > 0) {
      let searchResult = merchant.filter((i) => {
        let product = i.product_discription.toLowerCase().includes(searchTerm)
          ? i
          : "";
        return product;
      });
      setFilteredProducts(searchResult);
    } else if (searchTerm === "") {
      const myData = data.filter(
        (i) => i.merchant_user && i.merchant_user._id === merchant_id
      );
      setFilteredProducts([]);
      setMerchant(myData);
    }
  }, [searchTerm]);

  const addToCartHandler = (val) => {
    Event("PRODUCT", "Product added to cart", "PRODUCT_PAGE");
    console.log("val", val);
    addToCart(val);
  };

  const addToCart = (val) => {
    if (state === false) {
      dispatch(cart_actions.add_to_cart(val));
      gaAddToCart(val.product, val.quantity);
    } else {
      setOpen(true);
    }
  };

  useEffect(() => {
    if (user) {
      backend
        .get("/marketproduct", {
          params: {
            merchant_user: merchant_id ? merchant_id : id,
          },
        })
        .then(({ data: { data, message } }) => {
          setVacProducts(data);
        })
        .catch((err) => console.log(err.response.data.message));
    }
  }, [user]);

  const initAdcard = (i) => {
    dispatch(
      adcard_actions.create_adcard({
        product: i._id,
        expiry_date: addDate(),
      })
    );
  };

  const addDate = () => {
    var date = new Date();
    var answer = date.setDate(date.getDate() + 30);
    return new Date(answer)
      .toISOString()
      .replace(/T.*/, "")
      .split("-")
      .join("-");
  };
  const columns = [
    { title: "Product", field: "image" },
    { title: "Description", field: "description" },
    { title: "Price(USD)", field: "total_price", type: "numeric" },
    { title: "Upload EAC(USD)", field: "upload", type: "numeric" },
    { title: "Vac Prize(USD)", field: "vacPrize", type: "numeric" },
    { title: "Vac Contest Round", field: "vacContestRound" },
  ];

  const columnsCustomer = [
    { title: "Product", field: "image", editable: "never" },
    { title: "Description", field: "description", editable: "never" },
    { title: "Price(USD)", field: "total_price", type: "numeric" },
    { title: "Add to Cart", field: "action" },
  ];

  let data1 = [];
  if (merchant.length > 0) {
    merchant.forEach((i) => {
      let trimmed = i.product_discription.substring(0, 50);
      let item = vacProducts.find((item) => item.product === i._id);
      let date =
        typeof item !== "undefined"
          ? new Date(item.competition_month).toLocaleDateString()
          : "";

      data1.push({
        image: (
          <img
            className="col-md-10 justify-content-end align-items-center"
            src={i.product_images[0]?.image || null}
            alt="product"
          />
        ),
        description: `${trimmed}...`,
        id: i._id,
        total_price: `${i.product_price}`,
        vacPrize: item ? `${item.winner_price}` : "0",
        vacContestRound: typeof item !== "undefined" ? date : "-",
        upload: (
          <div>
            <p className="justify-content-center ml-4">
              {i.member_prize_value}
            </p>
            <Button
              className="btn btn-solid"
              onClick={() => {
                initAdcard(i);
              }}
            >
              Upload EAC
            </Button>
          </div>
        ),
        action: (
          <Button
            className="btn btn-solid"
            onClick={() => {
              addToCart({ product: i, quantity: quantity });
            }}
          >
            Add to Cart
          </Button>
        ),
      });
    });
  }

  let data2 = [];
  if (Boolean(filteredProducts.length)) {
    filteredProducts.forEach((i, index) => {
      addImpression(i, index);
      let trimmed = i.product_discription.substring(0, 50);

      data2.push({
        image: (
          <img
            className="col-md-10 justify-content-end align-items-center"
            src={i.product_images[0]?.image || null}
            alt="product"
          />
        ),
        description: `${trimmed}...`,
        id: i._id,
        total_price: `${i.product_price.toFixed(2)}`,
        upload: (
          <Button
            className="btn btn-solid"
            onClick={() => {
              initAdcard(i);
            }}
          >
            Upload EAC
          </Button>
        ),
        action: (
          <Button
            className="btn btn-solid"
            onClick={() => {
              addToCartHandler({ product: i, quantity: quantity });
            }}
          >
            Buy
          </Button>
        ),
      });
    });
  } else if (merchant.length > 0) {
    merchant.forEach((i, index) => {
      addImpression(i, index);
      let trimmed = i.product_discription.substring(0, 50);

      data2.push({
        image: (
          <img
            className="col-md-10 justify-content-end align-items-center"
            src={i.product_images[0]?.image || null}
            alt="product"
          />
        ),
        description: `${trimmed}...`,
        id: i._id,
        total_price: `${i.product_price.toFixed(2)}`,
        upload: (
          <Button
            className="btn btn-solid"
            onClick={() => {
              initAdcard(i);
            }}
          >
            Upload EAC
          </Button>
        ),
        action: (
          <Button
            className="btn btn-solid"
            onClick={() => {
              addToCartHandler({ product: i, quantity: quantity });
            }}
          >
            Buy
          </Button>
        ),
      });
    });
  }

  return (
    <div>
      <Helmet>
        <title>eksplode! | Product Catalogue </title>
      </Helmet>
      <div className={classes.root}>
        <Grid container className={classes.container}>
          <Grid item lg={9} sm={12} md={12} xs={12} className={classes.table}>
            <div className={classes.size}>
              {user && user?.user?.role === "member" ? (
                <MaterialTable title={title} columns={columns} data={data1} />
              ) : (
                <MaterialTable
                  title={title}
                  columns={columnsCustomer}
                  data={data2}
                />
              )}
            </div>
          </Grid>
          <Grid item lg={1}></Grid>
          <Modal  open={open} onClose={() => setOpen(false)} center>
            <div className="container px-5 pt-5 ">
              <div className="form-row mr-3">
                <div className="col-md-12 justify-content-center mb-3">
                  <h3>
                    Please complete your purchase first before buying from a
                    different retailer
                  </h3>
                </div>
                <br />
                <button
                  className="btn btn-solid mt-3"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Ok
                </button>
              </div>
            </div>
          </Modal>
        </Grid>
      </div>
    </div>
  );
};

export default ProductCatalogue;
